import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-complete-reg-confirmation',
  templateUrl: './complete-reg-confirmation.component.html',
  styleUrls: ['./complete-reg-confirmation.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, RouterModule],
})
export class CompleteRegConfirmationComponent {
  constructor(private modalCtrl: ModalController, private router: Router) {}

  async dismiss() {
    this.modalCtrl.dismiss();
  }

  goToCompleteReg() {
    this.router.navigate(['../complete-reg']);
    this.dismiss();
  }
}
